var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"bg-red-claro flex flex-row h-auto pb-3 pt-3 p-4 sm:p-6"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"importance":"high","src":"https://mondrian.claro.com.br/brands/horizontal/inverse/claro-controle.svg","alt":"Claro Controle"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }